<template>
	<div class="favorites">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
			<template #right>
				<van-icon name="add-o" @click="goRemindInfo()" />
			</template>
		</van-nav-bar>
		<div class="collapse">

			<van-sticky :offset-top="40">
				<van-notice-bar left-icon="bullhorn-o" :scrollable="false">
				  <van-swipe
					vertical
					:style="{height:'40px','line-height':'40px'}"
					:autoplay="3000"
					:show-indicators="false"
				  >
					<van-swipe-item :style="{height:'40px','line-height':'40px'}">
						① 关注公众号「熟柿子」
					</van-swipe-item>
					<van-swipe-item :style="{height:'40px','line-height':'40px'}">
						② 我的 > 右上角设置 > 微信账号绑定（微信授权登录请忽略）
					</van-swipe-item>
				  </van-swipe>
				</van-notice-bar>
				<van-tabs v-model="f_type" v-show="ftypes.length > 1">
					<van-tab :title="s.name" v-for="(s, i) in ftypes" :key="i"></van-tab>
				</van-tabs>
			</van-sticky>

			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    			<div class="empty" v-if="!loading&&items.length==0"><span class="msg">暂无记录</span></div>
				<van-list
				v-model="loading"
				:finished="true"
				:finished-text="''"
				@load="loadData"
				>
					<van-swipe-cell
					  v-for="(item,index) in items"
					  :key="f_type+index">
						<van-card :title="item.content"  @click="goRemindInfo(item)" >
							<template #desc>
								<div class="van-card__desc van-ellipsis">{{item.note}}</div>
							</template>
							<template #tags v-if="item.imgs">
								<div>
									<img :src="attach_url+uri" v-for="(uri,i) in item.imgs.split(';')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewEnvImg(item.imgs, i)"/>
								</div>
							</template>
							<template #num>
								{{item.rdate_beg}}{{item.rdate_end?('~'+item.rdate_end):''}} {{item.stime}}起提醒{{item.rtimes}}次{{item.rtimes>1?('（隔'+item.dtimes+'分钟）'):''}}
							</template>
						</van-card>

						<template #right>
							<van-button square text="移除" type="danger" class="van-swipe-cell-button"  @click="moveRemind(item.id)"/>
						</template>

					</van-swipe-cell>
				</van-list>
			</van-pull-refresh>
		</div>
		
		<van-popup v-model="showRemindInfo" position="bottom" :style="{ 'max-height': '80%' }">
			<van-cell-group :style="{'padding':'10px'}">
				<van-field
				  v-model="remindInfo.content"
				  rows="3"
				  autosize
				  :label="ftypes[f_type].title.cont"
				  type="textarea"
				  maxlength="1000"
				  :placeholder="'请输入'+ftypes[f_type].title.cont"
				  show-word-limit
				  required
				/>
				<van-field v-model.trim="remindInfo.note" maxlength="100" :label="ftypes[f_type].title.note" placeholder="请输入最多100字符">
				</van-field>
				<van-cell title="起始日期" :value="remindInfo.rdate_beg" @click="showRemindDateSel(1)" required>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="emptyRemindDate" :style="{'margin-left':'5px'}">清空</van-button></template>
				</van-cell>
				<van-cell title="结束日期" :value="remindInfo.rdate_end" @click="showRemindDateSel(2)">
				</van-cell>
				<van-cell title="提醒时间" :value="remindInfo.stime" @click="showStimeTime2Sel" required>
				</van-cell>
				<van-field v-model="remindInfo.rtimes" type="digit" label="提醒次数" >
					<template #button>
					次
					</template>
				</van-field>
				<van-field v-model="remindInfo.dtimes" type="digit" label="间隔时间" :disabled="remindInfo.rtimes<=1"  >
					<template #button>
					分钟
					</template>
				</van-field>
				<van-divider>最多可上传3张小于1M的图片</van-divider>
				<van-uploader multiple :max-size="imgSizeLimit" @oversize="onOversize" max-count="3" v-model="imgList" :before-read="beforeRead"/>

				<van-button type="primary" block @click="saveRemind()" >保存</van-button>
			</van-cell-group>


		</van-popup>

		<van-calendar v-model="showRemindDate" type="single" @confirm="onConfirmRemindDate" :default-date="remindDateSel[showRemindDateInd-1]" :min-date="minRemindDate"/>

		<van-popup v-model="showStimeTimePopup" position="bottom" @click-overlay="cancelStimeTime2Sel">
			<van-datetime-picker v-model="remindInfo.stime" type="time" title="提醒开始时间"
			@confirm="showStimeTimePopup=false"
			@cancel="cancelStimeTime2Sel"
			:filter="stimeSelFilter"
			/>
		</van-popup>
	</div>
</template>

<style scoped>
</style>

<script type="text/ecmascript-6">
import {  chkImgType,chkURL } from "@/utils/common.js";
import { Sticky, List, Card,Calendar,Divider,Swipe,SwipeItem,DatetimePicker,ImagePreview } from "vant";
export default {
	name: "message",
	components: {
		"van-sticky": Sticky,
		"van-list": List,
		"van-card": Card,
		"van-calendar": Calendar,
		"van-divider":Divider,
		"van-swipe":Swipe,
		"van-swipe-item":SwipeItem,
		"van-datetime-picker":DatetimePicker
	},
	data() {
		return {
			title: "日程提醒",
			items: [],
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,
			ftypes:[{key:1,name:'服药',title:{cont:'药品说明',note:'服用建议'}}],
			f_type:0,
			loading:true,
			refreshing:false,

			showRemindInfo:false,
			remindInfo:{},
			showRemindDate:false,
			showRemindDateInd:0,
			minRemindDate:new Date(),
			remindDateSel:[new Date(), new Date()],
			imgList:[],
			imgSizeLimit:1024 * 1024,
			showStimeTimePopup:false,
			stimeValBefore:''
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.loadRemindTypes();
		this.loadData();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		loadRemindTypes(){
			var url = this.Conf.serverUrl + "User/remindTypes" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify({}))
			.then(response => {
				this.ftypes = response.data.data;
			})
			.catch(error => {});
		},
		loadData() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				types: this.ftypes[this.f_type].key
			};
			var url = this.Conf.serverUrl + "User/remindList" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.loading = false;
				this.items = response.data.list;
			})
			.catch(error => {});
		},
		onRefresh(cur) {
			this.loading = true;
			this.loadData();
		},
		moveRemind(rid){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定删除此提醒日程",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					r_id: rid
				};
				var url = this.Conf.serverUrl + "User/delRemind" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.$toast(response.data.msg);
					switch (response.data.code) {
						case 200:
							this.onRefresh(true);
							break;
						default:
							return;
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		goRemindInfo(info){
			this.remindInfo = info||{u_id:this.u_id,types:this.ftypes[this.f_type].key,rtimes:1,dtimes:0,stime:'00:00'};
			this.imgList = [];
			if(this.remindInfo.imgs){
				var rimgs = this.remindInfo.imgs.split(';');
				for(var i in rimgs){
					this.imgList.push({url:this.attach_url+rimgs[i],path:rimgs[i]});
				}
			}
			this.showRemindInfo = true;
		},
		showRemindDateSel(t){
			this.showRemindDate = true;
			this.showRemindDateInd = t;
			if(t==2){
				this.minRemindDate = this.remindDateSel[0]
			}else{
				this.minRemindDate = new Date();
			}
		},
		emptyRemindDate(){
			this.remindInfo.rdate_beg=null;
			this.remindInfo.rdate_end=null;
			this.remindDateSel = [new Date(), new Date()];
			this.$forceUpdate();
		},
		onConfirmRemindDate(date) {
			this.remindDateSel[this.showRemindDate-1] = date;
			this.showRemindDate = false;
			var dstr = this.$options.filters['moment_format'](date.getTime(),'Y-MM-DD');
			if(this.showRemindDateInd==2){
				this.remindInfo.rdate_end = dstr;
			}else{
				this.remindInfo.rdate_beg = dstr;
				if(date.getTime() > this.remindDateSel[1]){
					this.remindDateSel[1] = date;
				}
				this.remindInfo.rdate_end = null;
			}
		},
		showStimeTime2Sel(){
			this.stimeValBefore = this.remindInfo.stime;
			this.showStimeTimePopup = true;
		},
		cancelStimeTime2Sel(){
			this.remindInfo.stime = this.stimeValBefore;
			this.showStimeTimePopup = false;
		},
		saveRemind(){
			if(!this.remindInfo.content){
				this.$toast.fail(this.ftypes[this.f_type].title.cont+'非空，请填写！');
				return false
			}
			if(!this.remindInfo.rdate_beg){
				this.$toast.fail('请选择提醒开始日期！');
				return false
			}
			if(!this.remindInfo.stime){
				this.$toast.fail('请选择提醒开始时间！');
				return false
			}
			if(this.remindInfo.rtimes>1&&this.remindInfo.dtime<=0){
				this.$toast.fail('多次提醒请填写每次间隔时间！');
				return false
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定保存当前日程信息吗？",
			})
			.then(() => {
			
				var formData = new window.FormData();
				formData.append('u_id',this.u_id);
				formData.append('token',this.token);
				formData.append('data',this.$qs.stringify(this.remindInfo));

				for(var i in this.imgList){
					if(this.imgList[i].content){
						formData.append('img_'+(parseInt(i)+1),this.imgList[i].content);
					}else{
						let phs = this.imgList[i].path.split("/");
						formData.append('img_'+(parseInt(i)+1), phs[phs.length-1]);
					}
				}

				var url = this.Conf.serverUrl + "User/saveRemind" + "?num=" + Math.random();
				let that = this;
				that.$axios
				.post(url, formData, { "Content-Type": "multipart/form-data" })
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						this.showRemindInfo = false;
						that.onRefresh(true);
					}
				})
				.catch(error => {});

				
			})
			.catch((error) => {});
			return false;
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 1M");
		},
		stimeSelFilter(type, options) {
			if (type === 'minute') {
				return options.filter((option) => option % 5 === 0);
			}
			return options;
		},
		previewEnvImg(imgs, i){
			imgs = imgs.split(";");
			var imgarr = [];
			for(var ii in imgs){
				imgarr.push(this.attach_url+imgs[ii]);
			}
			ImagePreview({
				images: imgarr,
				startPosition: i,
				showIndex:false,
				showIndicators:true
			});
		}
	},
	watch:{
		f_type(){
			this.onRefresh()
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Remind.vue